import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import Reveal from "./Reveal";

export default function FlowSection() {
  const { t } = useLang();
  const steps = t("flow.steps");
  return (
    <section data-testid="flow-section" className="bg-ink2 bg-grid-dark py-20 lg:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.25em] text-electric">{t("flow.eyebrow")}</p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight max-w-3xl">«{t("flow.title")}»</h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-wrap items-center gap-y-4">
            {steps.map((s, i) => (
              <div key={s} className="flex items-center">
                <span
                  className={`rounded-full border px-4 py-2 text-[11px] sm:text-xs font-bold tracking-widest transition-colors ${
                    i === steps.length - 1
                      ? "border-electric/60 bg-gradient-to-r from-dblue to-electric text-white"
                      : "border-white/15 bg-white/5 text-white/80"
                  }`}
                >
                  {s}
                </span>
                {i < steps.length - 1 && <ArrowRight className="mx-1.5 h-4 w-4 text-electric/70 shrink-0" />}
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.25}>
          <p className="mt-10 max-w-3xl text-base sm:text-lg text-steel leading-relaxed">{t("flow.copy")}</p>
        </Reveal>
      </div>
    </section>
  );
}
